<template>
  <modal :visible="visible" @close="close" :title="title" transition="fade">
    <div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
        </header>
        <section class="modal-card-body">
          <div>
            <p>{{ message }}</p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a class="button is-primary" @click="ok">{{ okText }}</a>
        </footer>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from 'vue-bulma-modal'

export default {
  components: {
    Modal
  },

  props: {
    visible: Boolean,
    title: String,
    message: String,
    okText: String,
    ok: Function,
    reload: false
  },

  methods: {
    close () {
      this.$emit('close')
      if (this.reload) {
        window.location.reload()
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// AlertModal.vue?a54182ee